import { render, staticRenderFns } from "./nimp_foreground_image.vue?vue&type=template&id=6f155a6c&scoped=true&"
import script from "./nimp_foreground_image.vue?vue&type=script&lang=js&"
export * from "./nimp_foreground_image.vue?vue&type=script&lang=js&"
import style0 from "./nimp_foreground_image.vue?vue&type=style&index=0&id=6f155a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f155a6c",
  null
  
)

export default component.exports